import React from 'react';
import HistoryPage from './HistoryPage';

export const VolunteerHistory = () => <HistoryPage apiEndpoint="https://annsevaa.onrender.com/api/history/volunteer/history" type="volunteer" />;